import { io } from "socket.io-client";

const URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_SOCKET_SERVER_URL_PROD
    : process.env.REACT_APP_SOCKET_SERVER_URL_DEV;

export const socket = io(URL || "https://ws.wacepay.io", {
  autoConnect: false,
  transports: ["websocket"],
});
